import { Link } from '@remix-run/react'
import { SectionEyebrow } from '#app/shared/ui/data-display/SectionEyebrow.tsx'
import { Button } from '#app/shared/ui/inputs/button/Button.tsx'

export const CtaBanner = () => {
  return (
    <section
      className={`
        relative isolate overflow-hidden bg-nosotros-bottom-hero-image bg-cover
        bg-center
      `}
    >
      <div
        className={`absolute inset-0 -z-10 bg-black/55`}
        aria-hidden="true"
      />

      <div
        className={`
          mx-auto flex max-w-[640px] flex-col items-center px-4 py-[74px]
          text-center
        `}
      >
        <SectionEyebrow className="mb-2 text-secondary">
          DÁ EL SIGUIENTE PASO
        </SectionEyebrow>
        <h2
          className={`
            mb-3 text-h3 text-white

            lg:text-h2 lg:leading-[52px]
          `}
        >
          ¿Listo para encontrar
          <br />
          tu coche óptimo?
        </h2>
        <div>
          <p className="text-base-medium text-white">
            Explora el stock disponible o contáctanos directamente
          </p>
          <p className="mb-5 text-base-medium text-white">
            — respondemos en menos de 24 horas.
          </p>
        </div>

        <div
          className={`
            flex flex-col items-center gap-3

            sm:flex-row
          `}
        >
          <Link to="/nuestros-coches">
            <Button variant="primary" className="h-11 px-6 font-normal">
              Explorar coches
            </Button>
          </Link>
          <Link to="/contacto">
            <Button
              variant="outlineInput"
              className={`
                h-11 border-white bg-white px-6 font-normal text-neutral-900

                hover:border-neutral-100 hover:bg-neutral-100
              `}
            >
              Contactar ahora
            </Button>
          </Link>
        </div>
      </div>
    </section>
  )
}
